import { Box, Modal, Typography } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  pt: 1,
  px: 2,
  pb: 1,
  justifyContent: 'flex-start'
};

export const NoAccessModal = ({open, setOpen}) => {

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={style}>
          <h2>Zugriff nicht möglich</h2>
          <Box sx={{mx: '20px !important'}}>
            Melde dich an, um Produkte hinzufügen zu können.
          </Box>
          <Typography onClick={handleClose} variant="h6" component="a" className="custom-button-root custom-link-root" href="/login">
              Login / Registrieren
          </Typography>
          <Typography onClick={handleClose} variant="h6" component="a" className="custom-button-root custom-link-root">
              Abbrechen
          </Typography>
        </Box>
      </Modal>
    </>
  );
}